export const environment = {
  production: false,
  apiUrl: 'https://backend.dev.veraxum.com'
};
